import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface SettingState {
  isContactUsPopupOpen: boolean;
  countryData:object
  selectedNews:object
}

const initialState: SettingState = {
  isContactUsPopupOpen: false,
  countryData:{},
  selectedNews:{}
};

const settingSlice = createSlice({
  name: 'settingsData',
  initialState,
  reducers: {
    _onOpenCloseContactUsPage: (state:any, action: PayloadAction<any>) => {
      state.isContactUsPopupOpen = action.payload;
    },
    _setCountryData:(state:any, action: PayloadAction<any>) =>{
      state.countryData = action.payload
    },
    _setSelectedCurrentNews:(state:any, action: PayloadAction<any>) =>{
      state.selectedNews = action.payload
    }
  },
});

export const {
    _onOpenCloseContactUsPage,
    _setCountryData,
    _setSelectedCurrentNews
} = settingSlice.actions;

export default settingSlice.reducer;
